import PropTypes from 'prop-types';

export const FEATURE_KEYS = {
  SESSION_MEETING: 'sessionMeeting',
  SESSION_MEETING_GROUP: 'sessionMeetingGroup',
  STAFF_PHYSICIAN: 'staffPhysician',
  STAFF_ASSISTANT: 'staffAssistant',
  PHYSICIAN_STATUS: 'physicianStatus',
  TEXT_SNIPPETS: 'textSnippets',
  MULTICAST_MESSAGE: 'multicastMessage',
  CHAT_CHARACTERS: 'chatCharacters',
  PAM: 'pam',
  PAM_PHONE_ASSISTANT: 'pamPhoneAssistant',
};
export const SUBSCRIPTION_PLANS = {
  CHATSPECIAL: 'CHATSPECIAL',
  VIDEOSPECIAL: 'VIDEOSPECIAL',

  BASIC: 'BASIC',
  STARTERMESSENGER: 'STARTERMESSENGER',
  STARTERSESSION: 'STARTERSESSION',
  STARTERMESSENGERSESSION: 'STARTERMESSENGERSESSION',
  PROFESSIONAL: 'PROFESSIONAL',
  PROFESSIONALPLUS: 'PROFESSIONALPLUS',
  ENTERPRISE: 'ENTERPRISE',

  PROFESSIONAL_XS: 'PROFESSIONALEXTRASMALL',
  PROFESSIONAL_S: 'PROFESSIONALSMALL',
  PROFESSIONAL_M: 'PROFESSIONALMEDIUM',
  PROFESSIONAL_L: 'PROFESSIONALLARGE',
  MESSENGER_S: 'MESSENGERSMALL',
  MESSENGER_M: 'MESSENGERMEDIUM',
  MESSENGER_L: 'MESSENGERLARGE',
};

export const FEATURE_PROP_TYPE = PropTypes.shape({
  active: PropTypes.bool,
  subscribed: PropTypes.bool,
  count: PropTypes.number,
  limit: PropTypes.number,
  resetCount: PropTypes.bool,
});
